import { ServicesLoaders } from '@wix/thunderbolt-symbols'
import { NamedSignalsServiceDefinition, TestServiceDefinition } from '@wix/thunderbolt-services'
import namedSignalsServiceConfig from './configs/namedSignalsServiceConfig'
import { StyleUtilsDefinition } from '@wix/style-utils'
import { FedopsLoggerDefinition } from '@wix/viewer-service-fedops-logger'

export const serviceLoaders: ServicesLoaders = {
	[TestServiceDefinition as string]: () => import('feature-test-service/service' /* webpackChunkName: "platformTestService" */),
	[NamedSignalsServiceDefinition as string]: () => import('feature-named-signals-service/service' /* webpackChunkName: "platformNamedSignalsService" */),
	[StyleUtilsDefinition as string]: () => import('feature-style-utils-service/service' /* webpackChunkName: "platformStyleUtilsService" */),
	[FedopsLoggerDefinition as string]: () => import('feature-fedops-logger-service/service' /* webpackChunkName: "platformFedopsLoggerService" */),
}

export const serviceConfigs: { [serviceDefinition: string]: any } = {
	[NamedSignalsServiceDefinition as string]: namedSignalsServiceConfig,
}
